export interface POIAddress {
  address: string;
}

export interface Price {
  amount: number;
  currency: string;
}

export interface PriceLevel {
  upperbound: number;
}

export interface Tag {
  name: string;
  isActive: boolean;
}

export enum RecommendationCategory {
  FOR_YOU = 'FOR_YOU',
  FOR_TRIP = 'FOR_TRIP',
  FOR_CONTEXT = 'FOR_CONTEXT',
}

export interface RecommendationDetails {
  category: RecommendationCategory;
  content: string;
}

export interface Review {
  content: string;
  // max_rating: number;
  rating: number;
  source: string;
}

export interface SourcedData {
  reviews: Review[];
  sourced_num_reviews: Record<string, number>;
  // sourced_ratings: Record<string, number>;
  // sourced_urls: Record<string, string>;
}

export interface Offer {
  booking_url: string;
  description: string;
  images: Record<string, string>;
  prices: Price[];
}

export interface PoiItem {
  images: string[];
  categories: string[];
  img: string;
  id: string;
  name: string;
  rating: number;
  explanations: string[];
  types: string[];
  tags: Tag[];
  description: string;
  prices?: Price[];
  price?: string;
  price_level?: PriceLevel;
  location?: POIAddress;
  booking_url?: string;
  url?: string;
  recommendations?: RecommendationDetails[];
  sourced_data?: SourcedData;
  offers: Offer[];
  children?: string[];
  parent?: string;
}

export type Timeslot = [number, number];

export enum LunchTime {
  ANY = 'Any',
  MORNING = 'Morning',
  AFTERNOON = 'Afternoon',
  EVENING = 'Evening',
  NIGHT = 'Night',
  NONE = '',
}

export interface DateDetails {
  date: Date;
  label: string;
  description: string;
}

export interface POIDetailsProps {
  selectedPoi: PoiItem;
  isMapViewAvailable?: boolean;
  alternatives?: PoiItem[];
  isLoading?: boolean;
  isRemoveAllowed?: boolean;
  isAddAllowed?: boolean;
  selectedDayLabel?: string;
  destinationName?: string;
  availableDates?: DateDetails[];
  getAvailableTimeSlots?: () => Promise<Timeslot[]>;
  savedPoiIds: Set<string>;
}

export interface AddEvent {
  poiId: string;
  lunchTime: LunchTime;
  timeslot?: Timeslot;
}

// events
// @show-details: (poiID: string) user selected one of the activities
// @add: (evt: AddEvent) user decided to add alternative or selected poi
// @remove: (empty, supposed to remove selected poi)
